const BranchCourse = {
    "branch_course": "Branch Course",
    "institute": "Institute",
    "branch": "Select Office",
    "course": "Course",
    "status": "Status",
    "search": "Search",
    "error_institute": "Select Institute",
    "error_branch": "Select Branch Office",
    "error_course": "Select Course",
    "error_status": "Select Status",
    "table_institute": "INSTITUTE",
    "table_branch": "BRANCH OFFICE",
    "table_course": "COURSE",
    "table_status": "STATUS",
}

export default BranchCourse;
